export const getMaxOrderArea = [
  '',
  `query getMaxOrderArea {
    getMaxOrderArea
   }
`,
  'getMaxOrderArea'];
